<template>
    <div class="invoice">
        <Header :companyName="companyName" :logo="logo"></Header>

        <Properties
                :clientName="clientName"
                :invoiceNum="invoiceNum"
                :sellerName="sellerName"
                :dateCustom="dateCustom"
                :address="address"
                :addressIs="addressIs"
                :dateIs="dateIs"
                :clientNameIs="clientNameIs"
                :invoiceNumIs="invoiceNumIs"
                :sellerNameIs="sellerNameIs"
                :propsLeftCustom="propsLeftCustom"
                :propsRightCustom="propsRightCustom"

        ></Properties>

        <Products :value="products"></Products>

        <Report :totalPrice="this.totalPrice" :priceWithTax="this.priceWithTax"  :taxPrice="taxPrice"></Report>

        <Additinal :messages="messages"></Additinal>
    </div>
</template>

<script>
    import Header from "./Header"
    import Properties from "./Properties"
    import Products from "./Products"
    import Report from "./Report"
    import Additinal from "./Additinal"

    export default ({
        data: () => ({
            "priceWithTax": 0,
            "totalPrice": 0,
        }),
        props: {
            companyName: {},
            clientName: {},
            invoiceNum: {},
            sellerName: {},
            dateCustom: {},
            address: {},
            addressIs: {Boolean},
            dateIs: {Boolean},
            clientNameIs: {Boolean},
            invoiceNumIs: {Boolean},
            sellerNameIs: {Boolean},
            products: {},
            logo: {},
            messages: {},
            totalPriceP: {},
            taxPrice: {},
            priceWithTaxP: {},
            propsLeftCustom: {},
            propsRightCustom: {},


        },
        methods: {
            calculatingTotalPrice() {

                this.products.forEach((item) => {
                    this.totalPrice += (item.price * item.quantity)
                })

                this.totalPrice = this.financial(this.totalPrice)
            },
            calculatingPriceWithTax() {

                this.products.forEach((item) => {
                    this.priceWithTax += (item.price * item.quantity)
                })

                if (this.taxPrice != "" && this.taxPrice != undefined && !isNaN(this.taxPrice)) {
                    this.priceWithTax += this.taxPrice
                }

                this.priceWithTax = this.financial(this.priceWithTax)
            },
            financial(x) {
                return Number.parseFloat(x).toFixed(2);
            }
        },
        components: {
            Header,
            Properties,
            Products,
            Report,
            Additinal
        },
        mounted() {
            console.log(this.totalPriceP)
            if (this.totalPriceP == "default" || this.totalPriceP == undefined || this.totalPriceP == "")
                this.calculatingTotalPrice();
            else this.totalPrice = this.totalPriceP

            if (this.priceWithTaxP == "default" || this.priceWithTaxP == undefined || this.priceWithTaxP == "")
                this.calculatingPriceWithTax()
            else this.priceWithTax = this.priceWithTaxP
        }
    })
</script>


<style scoped>
    .invoice {
        width: 40%;
        display: block;
        margin: 30px auto;
        background-color: rgb(230, 225, 225);
        padding: 30px 0px;
        box-shadow: -20px 80px 50px rgba(163, 163, 163, 0.5), -30px 90px 20px rgba(110, 109, 103, 0.44);
        padding-bottom: 50px;
    }
</style>
